import { truncateDecimals } from '@lair-finance/util'
import { formatEther } from 'ethers'
import { Address } from 'viem'

export const commafy = (value: number | string): string => {
  const num = Number(value)
  if (isNaN(num)) {
    return value.toString()
  }

  if (num === 0) {
    return '0'
  }

  const [integerPart, decimalPart] = value.toString().split('.')
  const isNegative = integerPart.startsWith('-')
  const absInteger = isNegative ? integerPart.slice(1) : integerPart

  const withCommas = absInteger.replace(/\B(?=(\d{3})+(?!\d))/g, ',')

  const finalInteger = isNegative ? `-${withCommas}` : withCommas
  return decimalPart ? `${finalInteger}.${decimalPart}` : finalInteger
}

export const formatNumberToMillion = (num: number, decimalPlaces: number = 1) => {
  if (num >= 1_000_000) {
    return parseFloat(Math.floor(num / 1_000_000).toFixed(decimalPlaces)) + 'M'
  }
  return parseFloat(num.toFixed(decimalPlaces)).toString()
}

export const formatNumberToKilo = (num: number, decimalPlaces: number = 1): string => {
  if (num >= 1_000) {
    return parseFloat(Math.floor(num / 1_000).toFixed(decimalPlaces)) + 'K'
  }
  return parseFloat(num.toFixed(decimalPlaces)).toString()
}

export const formatTVL = (value: number | string, decimalPlaces: number = 1) => {
  const numericValue = typeof value === 'string' ? parseFloat(value) : value
  return commafy(truncateDecimals(numericValue, numericValue >= 1_000 ? 0 : decimalPlaces))
}

export const formatRestakingTVL = (value: number | string, decimalPlaces: number = 2) => {
  const numericValue = typeof value === 'string' ? parseFloat(value) : value
  return { value: truncateDecimals(numericValue / 1_000_000, decimalPlaces), unit: 'M' }
}

export function formatEtherToDecimal(wei: bigint, decimals = 4) {
  const ether = formatEther(wei)
  return truncateDecimals(ether, decimals)
}

export function normalizeAddress(address: Address | string) {
  return address.toLowerCase().trim() as Address
}
